<template>
    <v-card>
        <v-card-text class="py-7">
            <div class="mb-3">
                <v-img
                    :src="require('@/assets/loading2.gif')"
                    contain
                    height="150"
                ></v-img>
            </div>

            <div
                class="font-weight-bold text-center black--text"
                style="font-size: 16px"
            >
                Sedang Melakukan<br />
                Pengecekan File
                {{ liveClassTotalCheckRow || 0 }} /
                {{ liveClassTotal || 0 }}
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        liveClassTotal: { type: Number, default: 0 },
        liveClassTotalCheckRow: { type: Number, default: [] },
    },
    name: "DialogUploadValidation",
};
</script>



// WEBPACK FOOTER //
// DialogUploadValidation.vue?65c74f19